import {Box, Flex, Text, Title} from 'exsportia-components'
import {useFormikContext} from 'formik'
import {FC} from 'react'

import {SignUpFormType} from '../../../services/auth/forms/sign-up-form'
import {useAppLoading} from '../../../services/global/hooks'
import {Button} from '../../../ui/components/button/button'
import {Input} from '../../../ui/components/input/input'
import {useLocale} from '../../../utils/i18n'

type NameSignUpStepProps = {
  handleGoToNextStep: () => void
  backAction?: (e: Event) => void
}

const trimName = (name: string) => name.trim().replace(/\s+/g, ' ')

export const NameSignUpStep: FC<NameSignUpStepProps> = ({handleGoToNextStep, backAction}) => {
  const {l} = useLocale()
  const {isLoading} = useAppLoading()
  const {validateForm, setValues, values} = useFormikContext<SignUpFormType>()
  const handleNext = () => {
    (async () => {
      const newValues = {
        ...values,
        lastName: trimName(values.lastName),
        firstName: trimName(values.firstName),
      }
      setValues(newValues)
      const validateResult = await validateForm(newValues)
      if (!validateResult.firstName && !validateResult.lastName) {
        handleGoToNextStep()
      }
    })()
  }

  return (
    <Box pb={'24px'}>
      <Flex mb='8px'>
        <Title
          text={l('tellUsAboutYourself')}
          styleType='h2'
        />
      </Flex>
      <Flex mb='16px'>
        <Text text={l('enter_your_first_and_last_names', {caseAction: 'capitalize'})} />
      </Flex>
      <Input
        label={l('firstName')}
        id={'firstName'}
      />
      <Input
        label={l('lastName')}
        id={'lastName'}
      />
      <Flex
        gap='16px'
        mt={'16px'}
      >
        {backAction && (
          <Button
            disabled={isLoading}
            type='secondary'
            onClick={backAction}
          >
            {l('back')}
          </Button>
        )}
        <Button disabled={isLoading} onClick={handleNext}>{l('next')}</Button>
      </Flex>
    </Box>
  )
}
